import { useParams } from 'react-router-dom';

import AssemblyFlexiblePage from './AssemblyFlexiblePage';
import { getMappedPageContent } from './mappers';

import PageContainer from 'components/custom/page-container/PageContainer';
import {
  GetFlexibleAssemblyDocument,
  GetFlexibleAssemblyQuery,
  GetTopContentSectionDocument,
  GetBottomContentSectionDocument,
  GetTopContentSectionQuery,
  GetBottomContentSectionQuery,
} from 'graphql/__generated/sdk';
import useI18nQuery from 'utils/hooks/useI18nQuery';

type Props = {
  Slug?: string;
};

export default function Assemblyflexible({ Slug }: Props) {
  const { slug } = useParams();
  const pageSlug = Slug ?? slug;

  const baseQuery = useI18nQuery<GetFlexibleAssemblyQuery>(GetFlexibleAssemblyDocument, {
    variables: {
      slug: pageSlug,
    },
  });

  const topContentQuery = useI18nQuery<GetTopContentSectionQuery>(GetTopContentSectionDocument, {
    variables: {
      slug: pageSlug,
    },
  });

  const bottomContentQuery = useI18nQuery<GetBottomContentSectionQuery>(
    GetBottomContentSectionDocument,
    {
      variables: {
        slug: pageSlug,
      },
    }
  );

  return (
    <PageContainer<
      [GetFlexibleAssemblyQuery, GetTopContentSectionQuery, GetBottomContentSectionQuery],
      any
    >
      queryList={[baseQuery, topContentQuery, bottomContentQuery]}
      mapperFn={getMappedPageContent}
    >
      {(result) => (
        <AssemblyFlexiblePage
          heroBanner={result.heroBanner}
          showBreadcrumbs={result.showBreadcrumbs}
          socialMediaShare={result.socialMediaShare}
          contentSection={result.contentSection}
          anchorTabs={result.anchorTabs}
        />
      )}
    </PageContainer>
  );
}
